import React from "react"
import ReactDOM from "react-dom"
import InfoContentBlockComponent from "./info-content-block-component"

export default class InfoContentBlock {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<InfoContentBlockComponent {...this.modelJson} />, self.elem)
  }
}
